import React from "react";
import { getTourName } from "../../services/Tour";

const formatDate = (dateStr: string | null) => {
  if (!dateStr) return "—";
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return "—";
  return d.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
};

const PlatformBadge = ({ platform }: { platform: string | null }) => {
  if (platform === "ios") {
    return (
      <span className="px-2 py-1 text-xs font-semibold bg-blue-100 text-blue-700 rounded-full">iOS</span>
    );
  }
  if (platform === "android") {
    return (
      <span className="px-2 py-1 text-xs font-semibold bg-green-100 text-green-700 rounded-full">Android</span>
    );
  }
  return <span className="text-xs text-lightgray">—</span>;
};

const AppPurchasesTable = ({ rows }: any) => {
  return (
    <div className="overflow-x-auto">
      <table className="w-full text-sm text-left h-40 mb-9 min-w-[1000px]">
        <thead className="text-xs font-Roboto font-normal text-lightgray">
          <tr>
            <th scope="col" className="p-2">Date</th>
            <th scope="col" className="p-2">Platform</th>
            <th scope="col" className="p-2">User</th>
            <th scope="col" className="p-2">Email</th>
            <th scope="col" className="p-2">Product</th>
            <th scope="col" className="p-2">Order ID</th>
            <th scope="col" className="p-2">Amount (local)</th>
            <th scope="col" className="p-2">USD</th>
          </tr>
        </thead>
        <tbody>
          {rows?.map((r: any, idx: number) => {
            const fullName = [r.firstName, r.lastName].filter(Boolean).join(" ") || "—";
            const product = r.productName ? getTourName(r.productName, "en") : r.productId || "—";
            return (
              <tr key={r.id || idx} className="border-b border-aqua bg-white">
                <td className="p-2 whitespace-nowrap">{formatDate(r.createdAt)}</td>
                <td className="p-2"><PlatformBadge platform={r.platform} /></td>
                <td className="p-2">{fullName}</td>
                <td className="p-2">{r.email || "—"}</td>
                <td className="p-2">
                  {product}
                  {r.productType === "bundle" && (
                    <span className="ml-2 px-1.5 py-0.5 text-[10px] font-bold bg-purple-100 text-purple-700 rounded">BUNDLE</span>
                  )}
                </td>
                <td className="p-2 font-mono text-xs">{r.orderId || "—"}</td>
                <td className="p-2 whitespace-nowrap">
                  {r.amount != null
                    ? `${r.currency ? `${r.currency} ` : ""}${Number(r.amount).toFixed(2)}`
                    : "—"}
                </td>
                <td className="p-2 whitespace-nowrap">
                  {r.amountUSD != null ? `$${Number(r.amountUSD).toFixed(2)}` : "—"}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default AppPurchasesTable;
